<template>
    <div class="look descriptionsForm">
        <div>
            <el-page-header @back="close" content="查看酒店入住协议登记"></el-page-header>
        </div>
        <el-form :model="upsertForm" ref="upsertForm" label-width="80px" style="margin-top: 20px;" :inline="true" >
            <el-descriptions class="margin-top" :column="4" border size="mini" :labelStyle="{'width':'100px'}">
                <input type="hidden" :value="upsertForm.id">
                <el-descriptions-item>
                    <template slot="label">
                        <span style="color: #F56C6C;margin-right: 4px;">*</span>入住店面
                    </template>
                    <div>{{upsertForm.hotelName}}</div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span style="color: #F56C6C;margin-right: 4px;">*</span>房号
                    </template>
                    <el-form-item prop="houseName">
                        <div>{{upsertForm.houseName}}</div>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span style="color: #F56C6C;margin-right: 4px;">*</span>签字照片
                    </template>
                    <div>
                        <el-image style="width: 100px; height: 100px" v-if="upsertForm.writeName" :src="config.resPre+upsertForm.writeName" :preview-src-list="[config.resPre+upsertForm.writeName]"></el-image>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        查看协议
                    </template>
                    <div>
                        <el-button @click="lookCheck" type="primary">点击查看协议</el-button>
                    </div>
                </el-descriptions-item>
            </el-descriptions>
            <el-descriptions class="margin-top" :column="1" border size="mini" :labelStyle="{'width':'100px','height':'62px'}">
                <el-descriptions-item>
                    <template slot="label">
                        认领备注
                    </template>
                    <div>{{upsertForm.remark}}</div>
                </el-descriptions-item>
            </el-descriptions>
            <el-table border size="mini":stripe="true" :data="upsertForm.sysHotelCheckHistories">
                <el-table-column show-overflow-tooltip prop="idCard" label="身份证号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="phone" label="联系方式"></el-table-column>
                <el-table-column show-overflow-tooltip prop="f" label="身份证正面照片">
                    <template slot-scope="scope">
                        <el-image style="width: 100px; height: 100px" v-if="scope.row.idCardFrontImg" :src="config.resPre+scope.row.idCardFrontImg" :preview-src-list="[config.resPre+scope.row.idCardFrontImg]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="healthCodeImg" label="健康码照片">
                    <template slot-scope="scope">
                        <el-image style="width: 100px; height: 100px" v-if="scope.row.healthCodeImg" :src="config.resPre+scope.row.healthCodeImg" :preview-src-list="[config.resPre+scope.row.healthCodeImg]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="修改时间" sortable="custom"></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" sortable="custom"></el-table-column>
            </el-table>
        </el-form>
        <el-dialog :close-on-click-modal="false" title="协议内容"   width="650px" :visible.sync="look">
            <div v-html="content" style="height: 40rem;overflow-y: auto">

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button plain size="mini" @click="look = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "lookSysHotelCheckHistory",
        props: ['id'],
        data(){
            return {
                upsertForm:{
                    id:'',
                    adminId:'',
                    adminName:'',
                    hotelId:'',
                    hotelName:'',
                    houseName:'',
                    name:'',
                    idCard:'',
                    phone:'',
                    idCardFrontImg:'',
                    idCardReverseImg:'',
                    healthCodeImg:'',
                    runCodeImg:'',
                    userAgent:'',
                    browser:'',
                    os:'',
                    status:'',
                    startTime:'',
                    endTime:'',
                    days:'',
                    remark:'',
                    updateTime:'',
                    createTime:''
                },
                config:config,
                content:'',
                look:false
            }
        },
        created(){
            axios({
                url:`${home}/sysHotelCheck/update/findSysHotelCheckById/${this.id}`,
                method:'GET'
            }).then(res=>{
                Object.assign(this.upsertForm,res.data);
            }).catch(error=>{
                console.log(error);
            })
        },
        mounted(){

        },
        methods:{
            close(){
                this.$emit('update:visible');
            },
            lookCheck(){
                axios({
                    url: `${home}/sysDdList/findCheckInfo/${this.upsertForm.agreementId}`,
                    method: "GET"
                }).then(res => {
                    this.content = res.data.content;
                    this.look = true;
                }).catch(error => {

                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .look{
        margin: 20px 0 0 10px;
    }
</style>
